/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 7
// module chunks = 1 2